'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '@s7/base';
import { rem, packSX } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/* Высота пересекающейся с Input области */ var INTERSECTION_GAP = rem(64);
var styles = function(theme) {
    var _obj;
    return _extends({}, theme.fn.transition({
        duration: 380,
        fn: "ease-out"
    }), (_obj = {
        padding: rem("24 0")
    }, _obj[theme.fn.up("md1")] = {
        padding: rem("40 0")
    }, _obj["&[data-position-bottom=false]"] = {
        marginBottom: INTERSECTION_GAP
    }, _obj["&[data-position-bottom=true]"] = {
        marginTop: INTERSECTION_GAP
    }, _obj));
};
var SearchLayoutRoot = function(_param) {
    var children = _param.children, sx = _param.sx, others = _object_without_properties_loose(_param, [
        "children",
        "sx"
    ]);
    return /*#__PURE__*/ jsx(Box, _extends({
        sx: [].concat([
            styles
        ], packSX(sx))
    }, others, {
        children: children
    }));
};

export { SearchLayoutRoot };
